// extracted by mini-css-extract-plugin
export default {"formContainer":"AppForm_formContainer__4dBMU","error":"AppForm_error__6vfqF"};